<template>
    <div class="container" style="padding-top: 50px;">

        <div class="widget">

            <div style="padding:20px;text-align: center">
                <img src="../assets/logo-standart.png"/>
            </div>
            <br/>

            <!--            <div v-if="isMobile">-->
            <!--                <strong style="text-align: center !important;">-->
            <!--                    Bu sayfa mobil cihazla kullanmak için uygun değil, lütfen-->
            <!--                    daha geniş ekranlı bir bilgisayar ile tekrar deneyiniz.-->
            <!--                </strong>-->
            <!--                <br/>-->
            <!--                <a href="https://desafe.com.tr">www.desafe.com.tr adresine gitmek için tıklayınız</a>-->
            <!--            </div>-->

            <!--            <div v-if="!isMobile">-->
            <div>
                <el-steps :active="active" finish-status="success" align-center>
                    <el-step title="Gizlilik ve KVKK"></el-step>
                    <el-step title="İletişim Bilgileri"></el-step>
                    <el-step title="Şirket Bilgileri"></el-step>
                    <el-step title="Veri İşleme"></el-step>
                    <el-step title="Kayıt"></el-step>
                </el-steps>

                <div class="divider"></div>

                <div v-if="active===0" class="pane">

                    <h1 class="show--mobile h--title">Gizlilik ve KVKK</h1>

                    <div class="content-read">
                        <kvkk-component></kvkk-component>
                        <br/>
                        <privaty-component></privaty-component>
                        <br/>
                        <el-switch
                                v-model="acceptGDPR"
                                active-text="Okudum ve Onaylıyorum">
                        </el-switch>
                    </div>
                </div>

                <div v-if="active===2" class="pane">

                    <h1 class="show--mobile h--title">Şirket Bilgileri</h1>

                    <div class="content-form">

                        <div class="show--mobile">
                            <label>Kurum Türü:</label>
                            <el-select style="width: 100%;" placeholder="Kurum Türü" v-model="form.company.type">
                                <el-option v-for="item in types" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                            <label>Kurum Ünvanı:</label>
                            <el-input v-model="form.company.name"/>
                            <label>Kurumun Faaliyet Sektörü (NACE):</label>
                            <el-input v-model="form.company.nace"/>
                            <label>Kurumun ürünleri / hizmetleri:</label>
                            <el-input type="textarea" v-model="form.company.services"/>
                            <label>Kurumsal E-Posta Adresi:</label>
                            <el-input v-model="form.company.mail"/>
                            <label>
                                <el-checkbox v-model="form.mailConfirm"></el-checkbox>
                                Yazdığım e-posta adresi kişisel bir e-posta
                                adresidir.
                                Kişisel E-posta adresime
                                bilgi
                                mesajlarının gönderilmesini kabul ediyorum.
                            </label>
                            <el-alert
                                    title="İlk eğitimimize başladık: Kişisel e-posta adresleri kişisel verilerdir. Bu e-posta adreslerinin
                        kaydedilmesi kişisel veri işleme faaliyetidir. Bu adresler üzerinden iletişim kurulması ise
                        ilgili kişinin rızasını gerektirir."
                                    type="success" :closable="false">
                            </el-alert>
                        </div>

                        <div class="hide--mobile">
                            <label>Kurum Türü:</label>
                            <el-select style="width: 100%;" placeholder="Kurum Türü" v-model="form.company.type">
                                <el-option v-for="item in types" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                            <el-row :gutter="20">
                                <el-col :span="16">
                                    <label>Kurum Ünvanı:</label>
                                    <el-input v-model="form.company.name"/>
                                </el-col>
                                <el-col :span="8">
                                    <label>Kurumun Faaliyet Sektörü (NACE):</label>
                                    <el-input v-model="form.company.nace"/>
                                </el-col>
                            </el-row>
                            <label>Kurumun ürünleri / hizmetleri:</label>
                            <el-input type="textarea" v-model="form.company.services"/>
                            <label>Kurumsal E-Posta Adresi:</label>
                            <el-input v-model="form.company.mail"/>
                            <label>
                                <el-checkbox v-model="form.mailConfirm">Yazdığım e-posta adresi kişisel bir e-posta
                                    adresidir.
                                    Kişisel E-posta adresime
                                    bilgi
                                    mesajlarının gönderilmesini kabul ediyorum.
                                </el-checkbox>
                            </label>
                            <el-alert
                                    title="İlk eğitimimize başladık: Kişisel e-posta adresleri kişisel verilerdir. Bu e-posta adreslerinin
                        kaydedilmesi kişisel veri işleme faaliyetidir. Bu adresler üzerinden iletişim kurulması ise
                        ilgili kişinin rızasını gerektirir."
                                    type="success" :closable="false">
                            </el-alert>
                        </div>


                    </div>
                </div>

                <div v-if="active===3" class="pane">

                    <h1 class="show--mobile h--title">Veri İşleme</h1>
                    <div class="content-form">

                        <strong>Veri Kayıt Ortamları</strong>
                        <p>
                            Veri iş̧leyen kurumlar KVK Kurumu tarafından Veri Sorumlusu olarak isimlendirirler. Yani
                            Veri Sorumlusu kişi değil kurumun tüzel kişiliğidir. Bizde bundan sonra kurumunuza bu
                            şekilde hitap edeceğiz.
                        </p>

                        <hr/>

                        Kurumumuzda; <br/>
                        <br/>

                        <el-checkbox-group
                                v-model="form.data"
                        >
                            <el-checkbox v-for="item in list" :label="item" :key="item">{{item}}</el-checkbox>
                        </el-checkbox-group>

                    </div>
                </div>

                <div v-if="active===4" class="pane">
                    <h1 class="show--mobile h--title">Muafiyet</h1>

                    <div class="content-form">
                        <p>
                            Kurumunuzun VERBİS muafiyetinin olup olmadığını, eğer kayıt zorunluluğu varsa ne zamana
                            kadar yapılması gerektiğini
                            belirlemek için lütfen aşağıdaki bilgileri doldurunuz.
                        </p>
                        <label>Geçen Yıla Ait Mali Bilanço Aktif Toplamı:</label>
                        <el-select v-model="form.company.balance" style="width: 100%;">
                            <el-option v-for="balance in balances" :key="balance" :value="balance"
                                       :label="balance"></el-option>
                        </el-select>

                        <label>Toplam Personel Sayısı Aralığı:</label>
                        <el-select style="width: 100%;" v-model="form.company.emplooyes">
                            <el-option v-for="item in employees" :key="item" :label="item" :value="item"></el-option>
                        </el-select>

                        <el-alert
                                title="* 2019 yılı toplam çalışan sayısı baz alınarak cevaplanacaktır"
                                type="info alert" :closable="false">
                        </el-alert>
                        <el-alert
                                title="*Beyaz ve mavi yakalı toplam bordrolu ve/veya sözleşmeli personel sayısı"
                                type="info alert" :closable="false">
                        </el-alert>


                        <div class="divider"><br/></div>
                        <label>Varsa Şubelerinizin Lokasyonları:</label>
                        <el-input type="textarea" rows="10" v-model="form.company.substations"></el-input>
                        <el-alert
                                title="Lütfen her satıra bir lokasyon gelecek şekilde yazınız. Aynı şehirde birden fazla şubeniz varsa, şehir yanına rakamla belirtebiliriniz."
                                type="info" :closable="false">
                        </el-alert>

                    </div>
                </div>

                <div v-if="active===1" class="pane">

                    <h1 class="show--mobile h--title">İletişim Bilgileri</h1>

                    <div class="content-form">
                        <label>Adınız</label>
                        <el-input v-model="form.user.name"></el-input>
                        <label>Soyadınız</label>
                        <el-input v-model="form.user.surname"></el-input>
                        <label>Telefon Numaranız</label>
                        <el-input v-model="form.user.phone" placeholder="0 (  ) "
                                  v-mask="'0 (###) ### ## ##'"></el-input>
                        <label>Mail Adresiniz</label>
                        <el-input v-model="form.user.mail"></el-input>
                    </div>
                </div>
                <div v-if="active===5" class="pane">
                    <div class="content-read" style="text-align: center !important;">

                        <br/>
                        <br/>
                        <br/>

                        <h1>Teşekkürler.</h1>

                        <h3>Kayıt işleminiz tamamlanmıştır.</h3>

                        <br/>
                        <p>
                            Uzmanlarımız en kısa sürede size ulaşacaklardır.
                        </p>
                    </div>

                </div>

                <div class="divider"></div>
                <br/>
                <table width="100%" border="0" v-if="active<5">
                    <tr>
                        <td>
                            <el-button type="primary" @click="prev" :disabled="active===0">Önceki</el-button>
                        </td>
                        <td align="right">
                            <el-button type="success" @click="next">Sonraki</el-button>
                        </td>
                    </tr>
                </table>
            </div>


        </div>
    </div>

</template>

<script>

    // import './../gtm.js'

    export default {
        name: 'Home',
        data() {
            return {
                acceptGDPR: false,
                isMobile: false,
                form: {
                    formType: 'KAYIT',
                    company: {
                        type: null,
                        name: null,
                        nace: null,
                        services: null,
                        mail: null,
                        emplooyes: null,
                        substations: null,
                        balance: null
                    },
                    data: [],
                    mailConfirm: null,
                    applications: null,
                    user: {
                        name: null,
                        surname: null,
                        phone: null,
                        mail: null
                    }
                },
                active: 0,
                balances: [
                    '0-25 milyon TL',
                    '25 milyon TL ve üzeri'
                ],
                list: [
                    'ISO 27001 BGYS Sertifikalandırılmış ve işlemektedir.',
                    'KVKK uyumuna yönelik yönelik bir proje gerçekleştirilmiştir.',
                    'Kişisel Veri Envanteri oluşturulmuştur.',
                    'Kişisel Veri işlemeye yönelik hukuki metinler (aydınlatma beyanı, politika vs) yayınlanmıştır.',
                    'Doküman gizliliğine dair prosedürler oluşturulmuş, sınıflandırma ve etiketleme yapılmıştır.',
                    'Sistemlere, alt sistemlere ve kullanılan yazılımlara kimlerin erişebileceğine dair yetkilendirme matrisi mevcuttur.',
                    'Periyodik olarak yedekten dönme tatbikatları yapılmaktadır.',
                    'Periyodik olarak Sızma (penetrasyon) testleri yapılmaktadır.',
                    'Periyodik olarak farkındalık eğitimleri verilmektedir.',
                    'SOME (Siber Olaylara Müdahale Ekibi ) bulunmaktadır.',
                    'Kurumda kullanılan tüm yazılımları içeren yazılım envanteri bulunmaktadır.',
                    'Kurumda kullanılan tüm donanımları içeren donanım envanteri bulunmaktadır.',
                    'İş süreçleri yazılı olarak tanımlanmıştır.',
                    'İş süreçlerine dair akış diyagramları çizilmiştir.',
                    'Hukuk birimi bulunmaktadır.',
                    'Dışarıdan Hukuki Müşavirlik hizmeti alınmaktadır.',
                    'Kağıt imha makineleri bulunmaktadır.',
                    'Fiziksel arşiv bulunmaktadır.',
                    'E-ticaret Platformu bulunmaktadır.',
                    'Sistemlere, alt sistemlere ve kullanılan yazılımlara erişim logları merkezi olarak toplanmaktadır.',
                    'Bulutta depolama yapılmaktadır.',
                    'Bulutta yedekleme yapılmaktadır.',
                    'Bir çağrı merkezi bulunmaktadır.',
                    'Bir veri merkezi (sunucu odası) bulunmaktadır.',
                    'FKM (Felaket Kurtarma Merkezi) bulunmaktadır.',
                    'Kamera ile güvenlik takibi yapılmaktadır.',
                    'Personel devam kontrolü biometrik veri (parmak izi, yüz tanıma vs) ile yapılmaktadır.',
                    'Kurum dışından kullanıcılar kurum dosyalarına erişim sağlamaktadır.',
                    'Çalışanlar kendi bilgisayar veya tabletlerinden kurum kaynaklarına erişebilmektedir.',
                    'Bazı süreçlerimiz için dış kaynak (taşeron, iş ortağı vs) kullanılmaktadır.',
                    'Web site(ler)inde iletişim, iş başvurusu vs amaçla form doldurulabilmektedir.',
                    'CRM yazılımı kullanılmaktadır.',
                    'ERP yazılımı kullanılmaktadır.',
                    'Müşterilerimize özel üyelik-abonelik sistemimiz bulunmaktadır.',
                    'Başka Kurumlara kişisel veri aktarılabilmektedir.',
                    'Yurtdışına kişisel veri aktarılabilmektedir.',
                    'İK Yönetim yazılımı kullanılmaktadır.',
                    'Kendi Bünyenizde İşyeri hekimi bulunmaktadır.',
                    'Kendi Bünyenizde İSG uzmanı bulunmaktadır.',
                    'Kendi Bünyenizde Diğer Sağlık Personeli (Hemşire vb.) bulunmaktadır.',
                    'OSGB firması tarafından İşyeri Hekimi, İSG uzmanı, DSP hizmeti satın almaktayız.',
                    'Tüm tedarikçilerle gizlilik ve (ilgili durumlarda) kişisel veri işleme sözleşmesi yapılmıştır.',
                    'Tüm çalışanlarla gizlilik sözleşmesi yapılmıştır.'
                ],
                types: [
                    'Bağımsız Şirket (Ltd.,A.ş, Komandit,Kollektif vb.)',
                    'Holding',
                    'Yurtdışında Yerleşik Şirket',
                    'Kamu Kurumu',
                    'Siyasi Parti, Dernek-Vakıf...'
                ],
                employees: [
                    '1 - 10',
                    '11 - 49',
                    '50 - 99',
                    '100 - 199',
                    '200 - 299',
                    '300 - 399',
                    '400 - 499',
                    '500 - 749',
                    '750 - 999',
                    '1000+'
                ]
            }
        },
        created() {
            this.isMobile = this.checkMobile();
            this.$gtm.trackView('MyScreenName', 'currentpath');
        },
        methods: {
            next() {
                if (this.active === 0 && !this.acceptGDPR) {
                    alert('Lütfen Metinleri Okuyup Onaylayınız');
                    return false;
                }

                if (this.active === 2) {
                    let errors = '';
                    if (!this.form.company.type) {
                        errors += 'Lütfen geçerli bir kurum türü seçiniz.' + "\n";
                    }
                    if (!this.form.company.name) {
                        errors += 'Lütfen geçerli bir kurum ünvanı seçiniz.' + "\n";
                    }
                    if (!this.form.company.services) {
                        errors += 'Lütfen kurum hizmetleri hakkında bilgi veriniz.' + "\n";
                    }
                    if (!this.form.company.mail) {
                        errors += 'Lütfen bir mail adresi belirtiniz.' + "\n";
                    }
                    if (!this.checkMailValidate(this.form.company.mail)) {
                        errors += 'Lütfen geçerli bir mail adresi yazını.' + "\n";
                    }


                    if (errors) {
                        alert(errors);
                        return false;
                    }

                }

                if (this.active === 4) {
                    if (!this.form.company.balance) {
                        alert('Lütfen aktif bilanço belirtiniz.')
                        return false;
                    }
                    if (!this.form.company.emplooyes) {
                        alert('Lütfen kurumda çalışan personel sayısını belirtiniz.');
                        return false;
                    }
                }

                if (this.active === 1) {
                    let errors = '';
                    if (!this.form.user.name) {
                        errors += 'Lütfen adınızı yazınız.' + "\n";
                    }
                    if (!this.form.user.surname) {
                        errors += 'Lütfen soyadınızı yazınız.' + "\n";
                    }
                    if (!this.form.user.mail) {
                        errors += 'Lütfen size ulaşabileceğimiz mail adresinizi yazınız.' + "\n";
                    }
                    if (!this.form.user.phone) {
                        errors += 'Lütfen size ulaşabileceğimiz telefon numaranızı yazınız.' + "\n";
                    }
                    if (!this.checkMailValidate(this.form.user.mail)) {
                        errors += 'Lütfen geçerli bir mail adresi yazınız.' + "\n";
                    }
                    if (errors) {
                        alert(errors);
                        return false;
                    }
                    this.$http.post('start', this.form);
                }

                if (this.active++ >= 5) this.active = 0;

                if (this.active === 5) {
                    this.$http.post('save', this.form);
                }
                this.$http.post('page', this.form);
            },
            prev() {
                if (this.active-- <= 0) this.active = 0;
            },
            checkMobile() {
                let check = false;
                (function (a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
                })(navigator.userAgent || navigator.vendor || window.opera);
                return check;
            },
            checkMailValidate(email) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        }
    }
</script>
